<template>
  <div class="church-map-section">
    <div ref="mapContainer" class="map-container"></div>
    <a :href="directionsLink" target="_blank" class="map-directions-btn">
      <i class="fa fa-location-arrow"></i>
      Como chegar
    </a>
  </div>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { getLocationLink } from '@/utils/location.js'

export default {
  name: 'ChurchMap',
  props: {
    latitude: { type: Number, default: -5.512294 },
    longitude: { type: Number, default: -47.456748 },
    churchName: { type: String, default: 'Igreja Nova Aliança El Shaday' },
  },
  computed: {
    directionsLink() {
      return getLocationLink(this.latitude, this.longitude)
    }
  },
  mounted() {
    this.initMap()
  },
  methods: {
    initMap() {
      const map = L.map(this.$refs.mapContainer, {
        center: [this.latitude, this.longitude],
        zoom: 16,
        scrollWheelZoom: false,
        attributionControl: false,
      })

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
      }).addTo(map)

      const icon = L.divIcon({
        html: '<i class="fa fa-map-marker" style="font-size:36px;color:#db0d0d;"></i>',
        iconSize: [36, 36],
        iconAnchor: [18, 36],
        className: 'map-custom-icon',
      })

      L.marker([this.latitude, this.longitude], { icon })
        .addTo(map)
        .bindPopup(`<strong>${this.churchName}</strong>`)
    }
  }
}
</script>

<style scoped>
.church-map-section {
  position: relative;
  width: 100%;
  max-width: 1080px;
  height: 300px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.13);
}

.map-container {
  width: 100%;
  height: 100%;
}

.map-directions-btn {
  position: absolute;
  bottom: 16px;
  right: 16px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #fff;
  color: #2c3e50;
  text-decoration: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: background-color 0.2s ease, color 0.2s ease;
}

.map-directions-btn:hover {
  background: #2c3e50;
  color: #fff;
}

.map-directions-btn .fa {
  font-size: 14px;
}

@media screen and (max-width: 981px) {
  .church-map-section {
    height: 250px;
  }
}
</style>

<style>
.map-custom-icon {
  background: none !important;
  border: none !important;
}
</style>
